import {type OidcClientSettings, User} from 'oidc-client-ts';
import {authProviderProps} from '../../authProviderProps';

/**
 * Retrieves the current authenticated user from local storage.
 * This function is specific to the react-oidc-context library
 * https://github.com/authts/react-oidc-context
 */
export function getOidcUser() {
  const oidcStorage = localStorage.getItem(
    `oidc.user:${(authProviderProps as OidcClientSettings).authority}:${(authProviderProps as OidcClientSettings).client_id}`,
  );
  if (!oidcStorage) {
    return null;
  }

  return User.fromStorageString(oidcStorage);
}
